import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f428f70&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=4f428f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f428f70",
  null
  
)

export default component.exports